/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface CreateActivityResponseDto
 */
export interface CreateActivityResponseDto {
    /**
     * Activity ID
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'deletedAt': string;
    /**
     * Name of the activity
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'name': string;
    /**
     * Description of the activity
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'description'?: string;
    /**
     * External source ID for the activity
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'sourceId'?: string;
    /**
     * External source external ID for the activity
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'sourceExternalId'?: string;
    /**
     * Source of the activity
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'source': CreateActivityResponseDtoSourceEnum;
    /**
     * Distance covered in meters
     * @type {number}
     * @memberof CreateActivityResponseDto
     */
    'distance': number;
    /**
     * Duration of activity in seconds
     * @type {number}
     * @memberof CreateActivityResponseDto
     */
    'duration': number;
    /**
     * Type of activity
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'type': CreateActivityResponseDtoTypeEnum;
    /**
     * ActivityDate date in UTC
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'activityDate': string;
    /**
     * User ID who performed the activity
     * @type {string}
     * @memberof CreateActivityResponseDto
     */
    'userId': string;
    /**
     * Array of image URLs associated with this activity
     * @type {Array<string>}
     * @memberof CreateActivityResponseDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Array of participation IDs that this activity was submitted to
     * @type {Array<string>}
     * @memberof CreateActivityResponseDto
     */
    'participationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was approved for
     * @type {Array<string>}
     * @memberof CreateActivityResponseDto
     */
    'approvedParticipationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was declined for
     * @type {Array<string>}
     * @memberof CreateActivityResponseDto
     */
    'declinedParticipationRecords': Array<string>;
    /**
     * User who performed the activity
     * @type {UserDto}
     * @memberof CreateActivityResponseDto
     */
    'user': UserDto;
}

export const CreateActivityResponseDtoSourceEnum = {
    Strava: 'strava',
    Garmin: 'garmin',
    Manual: 'manual',
    AppleHealth: 'apple_health'
} as const;

export type CreateActivityResponseDtoSourceEnum = typeof CreateActivityResponseDtoSourceEnum[keyof typeof CreateActivityResponseDtoSourceEnum];
export const CreateActivityResponseDtoTypeEnum = {
    Run: 'run',
    Bike: 'bike',
    Swim: 'swim'
} as const;

export type CreateActivityResponseDtoTypeEnum = typeof CreateActivityResponseDtoTypeEnum[keyof typeof CreateActivityResponseDtoTypeEnum];


